__turbopack_context__.v({
  "block": "styles-module-scss-module__eP4KGG__block",
  "container": "styles-module-scss-module__eP4KGG__container",
});
